import {Injectable} from '@angular/core';
import {HttpObservable, HttpWrapper} from '../../http-helpers/http.wrapper';
import {Language} from '../interfaces/language';

@Injectable({
  providedIn: 'root'
})
export class IntlProxyPP {

  constructor(private httpWrapper: HttpWrapper) { }

  public getLanguages(): HttpObservable<Language[]> {
    return this.httpWrapper.getAnon('PatientPortalIntl', 'GetLanguages');
  }
}
